// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"180":"5bf7656145318a6d","514":"8a806dc20ca9d725"}[chunkId] + ".css";
};